import React from "react";
import NsDashboardCard from "../../../components/NsDashboardCard";
import Translate from "../../../components/Translate";

export default function DashboardNotificheView({
                                                   notifiche,
                                                   history,
                                                   translate,
                                                   aggiornaNotifica,
                                               }) {

    return (
        <NsDashboardCard
            title={'Notifiche'}
            classiAggiuntive={"ns-card--h340 ns-card--h340--padding-sm"}
        >
            {
                notifiche.length === 0 ?
                    <div className="sost-dashboard-text-center">
                        <Translate>Nessuna notifica da visualizzare</Translate>
                    </div>
                    :
                    <div className={"ns-overflow-y-auto h-100 pe-2 ps-2"}>
                        {
                            notifiche.map((n, idx) =>
                                <div
                                    key={idx}
                                    className="row sost-stato-kpi_notifiche w-100 ns-riga--notifiche"
                                >
                                    <div className="col-10 ns-mouse-pointer"
                                         onClick={() => {
                                             history.push("/info-kpi/" + n.id_kpi + '/' + n.id_tipo_imp_dati)
                                         }}
                                    >
                                        {translate(n.messaggio)}
                                    </div>
                                    <div className={"col-2 text-end"}>
                                        <i
                                            title={translate("Segna come letta")}
                                            className={"fas fa-times ns-mouse-pointer"}
                                            onClick={() => {
                                                aggiornaNotifica(n);
                                            }}
                                        />
                                    </div>
                                </div>
                            )
                        }
                    </div>

            }
        </NsDashboardCard>
    );
}